export default [
	//拜访详情
	{
		path: 'visitDetail',
		name: 'visitDetail',
		component: () => import('@/views/crmManage/visitManage/visitDetail.vue'),
	},
]
